// @flow
import { applyMiddleware, compose, createStore } from 'redux'
import thunk from 'redux-thunk'
import { reactReduxFirebase } from 'react-redux-firebase'
import firebase from 'services/firebase'
// import { createHashHistory } from 'history'
// import { routerMiddleware } from 'react-router-redux'
import rootReducer from 'reducers'

// const history = createHashHistory()
// const router = routerMiddleware(history)
const enhancer = applyMiddleware(
  thunk
  // router
)

const createStoreWithFirebase = compose(
  reactReduxFirebase(firebase, {
    userProfile: 'users'
  })
)(createStore)

const configureStore = initialState =>
  createStoreWithFirebase(rootReducer, initialState, enhancer)

export default {
  configureStore
  // history
}



// WEBPACK FOOTER //
// ./src/store/configureStore.prod.js